
import { Vue, Component, Prop, Watch } from "vue-property-decorator";
import * as echarts from "echarts";

export interface LineDataType {
  lineName: string; // 折线名称
  xData: string[]; // x轴数据
  yData: number[]; // y轴数据
}
const xData = ["周一", "周二", "周三", "周四", "周五", "周六", "周日"];
const yData = [20, 32, 41, 34, 66, 30, 50];
const lineName = "销售笔数";
@Component
export class LineChart extends Vue {
  @Prop({ default: () => ({ xData, yData, lineName }) }) params!: LineDataType;
  @Prop({ default: false }) simple!: boolean; // 是否简易图表
  chart: any = null;
  chartData: any[] = [];
  chartColorList = ["#1A5EF9", "#21CCFF", "#A98ADE", "#3491FA", "#0FC6C2"];

  @Watch("params", { deep: true })
  onParamsChange() {
    this.getData();
  }

  mounted() {
    console.log("params", this.params);
    this.chart = echarts.init(this.$refs.lineChartRef as HTMLElement);
    this.getData();
  }

  getData() {
    setTimeout(() => {
      this.$set(this.chartData, 0, { name: this.params.lineName, value: "" });
      if (this.simple) {
        this.chart.setOption(this.simpleOption());
        return;
      }
      this.chart.setOption(this.normalOption());
    }, 1000);
  }

  normalOption() {
    return {
      grid: {
        containLabel: true,
        left: 24,
        right: 30,
        top: 30,
        bottom: 0,
      },
      tooltip: {
        trigger: "axis",
        textStyle: { fontSize: 12, color: "#4E5969", align: "left" }, // 文字大小和颜色
        axisPointer: {
          type: "line",
          lineStyle: {
            type: "solid",
            color: "#94BFFF",
          },
          z: 1,
        },
      },
      xAxis: {
        type: "category",
        data: this.params.xData,
        axisLabel: {
          color: "#4E5969",
        },
        axisLine: {
          lineStyle: {
            color: "#C9CDD4",
          },
        },
        // 刻度线配置
        axisTick: {
          show: false,
        },
      },
      yAxis: {
        type: "value",
        nameTextStyle: {
          align: "right",
          color: "#4E5969",
        },
        axisLabel: {
          color: "#4E5969",
          formatter: "{value}",
        },
        axisLine: {
          lineStyle: {
            color: "#4E5969",
          },
        },
        splitLine: {
          lineStyle: {
            color: "#E5E6EB",
            type: "dashed",
          },
        },
      },
      series: [
        {
          name: this.params.lineName,
          type: "line",
          width: "100%",
          data: this.params.yData, // 这里数据根据图大致模拟，需替换为真实数据
          smooth: true,
          showSymbol: false, // 关键配置：隐藏数据点标记
          symbolSize: 16,
          z: 10,
          itemStyle: {
            color: "#1A5EF9",
            // borderWidth: 1,
            // boxShadow: "0px 2px 8px 0px rgba(0,0,0,0.1)",
          },
          lineStyle: {
            color: "#1A5EF9",
          },
        },
      ],
    };
  }

  simpleOption() {
    const maxY = Math.max(...this.params.yData);
    const minY = Math.min(...this.params.yData);
    return {
      grid: {
        containLabel: false,
        left: 0,
        right: 0,
        top: 1,
        bottom: 1,
      },
      xAxis: {
        show: false,
        type: "category",
        data: this.params.xData,
        axisLabel: {
          color: "#4E5969",
        },
        axisLine: {
          lineStyle: {
            color: "#C9CDD4",
          },
        },
        boundaryGap: false,
      },
      yAxis: {
        show: false,
        type: "value",
      },
      series: [
        {
          name: this.params.lineName,
          type: "line",
          width: "100%",
          data: this.params.yData, // 这里数据根据图大致模拟，需替换为真实数据
          smooth: true,
          showSymbol: false, // 关键配置：隐藏数据点标记
          itemStyle: {
            color: "#1A5EF9",
          },
          lineStyle: {
            color: "#1A5EF9",
            width: 2,
          },
          areaStyle: {
            opacity: 0.8,
            color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
              {
                offset: 0,
                color: "rgba(26, 94, 249, 0.18)",
              },
              {
                offset: 1,
                color: "rgba(26, 94, 249, 0.06)",
              },
            ]),
          },
          markLine: {
            silent: true, // 不触发事件
            symbol: "none", // 不显示首尾符号
            lineStyle: {
              type: "dashed",
              color: "rgba(26,94,249,0.12)",
              width: 2,
              opacity: 0.8,
            },
            data: [
              {
                yAxis: (maxY + minY) / 2,
              },
            ],
          },
        },
      ],
    };
  }
}
export default LineChart;
